<template>
  <div>
    <div class="text-3xl mb-8">Ansprechpartner</div>

    <!--- ROW ---->
    <div class="flex flex-wrap -mx-2">
      <div class="w-full md:w-1/2 px-2 mb-6">
        <div class="mb-2">Anrede: *</div>
        <multiselect :options="options" v-model="agencyInput.contact_gender" :searchable="false"></multiselect>
      </div>

      <div class="w-full md:w-1/2 px-2 mb-6">
        <div class="mb-2">Name: *</div>

        <v-input v-model="agencyInput.contact_name" name="name" rules="required"></v-input>
      </div>

      <div class="w-full md:w-1/2 px-2 mb-6">
        <div class="mb-2">E-Mail: *</div>
        <v-input v-model="agencyInput.contact_email" name="email" rules="required|email"></v-input>
      </div>

      <div class="w-full md:w-1/2 px-2 mb-6">
        <div class="mb-2">Telefonnummer: *</div>

        <v-input
          v-model="agencyInput.contact_phone"
          name="phone_number"
          rules="required"
          placeholder="Telefonnummer"
        ></v-input>
      </div>
    </div>

    <button
      class="btn btn-primary mt-8"
      :class="{'btn-loading': loading}"
      @click="patch"
      :disabled="errors.count() > 0 || loading"
    >Speichern</button>
  </div>
</template>


<script>
import Multiselect from "@/components/Multiselect";
import accountClient from "@/api/merchant/account";

export default {
  components: {
    Multiselect
  },

  props: ["agency"],

  data() {
    return {
      loading: false,
      agencyInput: {},
      options: [
        {
          label: "Herr",
          value: "m"
        },
        {
          label: "Frau",
          value: "f"
        }
      ]
    };
  },

  watch: {
    agency: {
      handler() {
        this.agencyInput = JSON.parse(JSON.stringify(this.agency));
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    patch() {
      this.validateAll().then(state => {
        if (state) {
          this.loading = true;
          accountClient
            .patch(this.agencyInput)
            .then(() => {
              this.$emit("saved");
              this.$toasted.global.saved();
            })
            .catch(() => this.$toasted.global.error())
            .then(() => (this.loading = false));
        }
      });
    },

    validateAll() {
      return this.$validator.validateAll();
    }
  }
};
</script>
